<template>
  <div class="new-union" v-if="unionHead">
    <div
      class="nav-bar"
      :style="{ 'background-color': unionHead.unionConfigurationDto.colour }"
    >
      <div class="nav-bar__wrapper nf-flex">
        <HomeLink :unionHead="unionHead"></HomeLink>
        <CitySelector class="right"></CitySelector>
        <Message v-if="loginData.userStatus == 2" class="nf-ml-40"></Message>
        <Language class="nf-ml-40"></Language>
        <User
          v-if="loginData.userStatus == 2"
          class="nf-ml-40"
          :unionHead="unionHead"
          :loginData="loginData"
        ></User>
      </div>
    </div>
    <Notice v-if="isShowNotice">{{ currentNoticeContent }}</Notice>
    <div
      class="header-body"
      :style="`background-image:url(${unionHead.unionConfigurationDto.bgImage}); background-repeat: no-repeat; background-size: cover`"
    >
      <img v-if="unionLogo" class="logo" :src="unionLogo" alt />
      <div class="channels">
        <Channels
          v-if="unionMenu && unionMenu.length > 0"
          :menu="unionMenu"
          :isActive="isMenuActive"
          :color="unionHead.unionConfigurationDto.colour"
        />
      </div>
      <div class="contact">
        <div class="contact-tel">
          <img src="@/assets/imgs/header-tel.png" alt />
          <span>{{ unionPhone }}</span>
        </div>
        <div class="contact-time">{{ unionPhoneTime }}</div>
      </div>
      <!-- <img class="contact" :src="unionHead.unionConfigurationDto.pcPhoneUrl" alt /> -->
      <SearchBox
        v-if="unionHead.mallUnionConfigDto.isShowSearch"
        @search="onSumbit"
        :bgColor="unionHead.unionConfigurationDto.colour"
      ></SearchBox>
    </div>
  </div>
</template>

<script>
import CitySelector from "./CitySelector";
import HomeLink from "./HomeLink";
import Message from "./Message";
import User from "./User";
import Menu from "./Menu";
import Channels from "./Channels";
import Notice from "./Notice";
import SearchBox from "./SearchBox";
import Language from "./Language.vue";
import Cookies from "js-cookie";
import {
  gioClickHandle as gioHandle,
  getQueryString,
  getCookie,
} from "../../../utils";

export default {
  name: "NewUnion2023",
  components: {
    HomeLink,
    Menu,
    Channels,
    User,
    Message,
    CitySelector,
    Notice,
    SearchBox,
    Language,
  },
  data() {
    return {
      unionHead: null,
      loginData: null,
      unionMenu: [],
      unionLogo: "",
      unionPhone: "",
      unionPhoneTime: "",
      noticeData: null,
      noticeInit: {
        color: "#3d96e2",
        col1: 1,
        col2: 23,
      },
      lang: getCookie("df_lang") || "zh-CN",
    };
  },
  computed: {
    colour() {
      const { colour } = this.unionHead.unionConfigurationDto;
      return colour ? colour : "#2c2d78";
    },
    hoverStyle() {
      const { colour } = this.unionHead.unionConfigurationDto;
      return {
        color: colour ? colour : "#247dff",
        fontWeight: "bold",
      };
    },
    isShowNotice() {
      if (!this.noticeData) {
        return false;
      }
      if (!this.unionHead.mallUnionConfigDto) {
        return false;
      }
      const { openNotice, isShowUnionNotice } =
        this.unionHead.mallUnionConfigDto;
      return openNotice || isShowUnionNotice;
    },
    currentNoticeContent() {
      const { noticeContent } = this.noticeData;

      if (this.unionHead) {
        const { mallUnionConfigDto } = this.unionHead;

        if (mallUnionConfigDto) {
          const { openNotice, isShowUnionNotice, unionNoticeContent } =
            mallUnionConfigDto;

          if (openNotice) {
            if (isShowUnionNotice) {
              return noticeContent + unionNoticeContent;
            } else {
              return noticeContent;
            }
          } else {
            if (isShowUnionNotice) {
              return unionNoticeContent;
            }
          }
        }
      }

      return noticeContent;
    },
  },
  created() {
    // 获取登录状态
    this.getLoginStatus();
    // 获取工会信息
    this.getFindByUnion();

    // 获取工会菜单
    this.getFindUsableList();

    // 获取工会logo及客服信息
    this.getUnionLogoAndPhone();

    //获取工会信息
    this.getCompanyInfo();

    // 获取公告内容
    this.getNoticeData();
  },
  methods: {
    isMenuActive(item) {
      let path =
        window.sessionStorage.getItem("currentChannel") ||
        getCookie("phpUnionCurrentChannel") ||
        "Shows";
      if (item.key === path) {
        return true;
      }
      return false;
    },
    getFindByUnion() {
      // this.apis.headerApi.getFindByUnion().then(res => {
      //   this.unionHead = res;
      // });
      const cityId =
        (Cookies.get("address") && JSON.parse(Cookies.get("address")).cityId) ||
        getQueryString("city") ||
        145;
      this.apis.newBfdHeaderApi.getFindByUnion({ city: cityId }).then((res) => {
        this.unionHead = res.data;
      });
    },
    getLoginStatus() {
      // this.apis.headerApi.getLoginStatus().then(res => {
      //   sessionStorage.setItem('loginInfo', JSON.stringify(res));
      //   if (res.loginFlag) {
      //     this.loginData = res;
      //   } else {
      //     window.location.href = res.loginUrl;
      //   }
      // });
      this.apis.newBfdHeaderApi.getLoginStatus().then((res) => {
        sessionStorage.setItem("loginInfo", JSON.stringify(res.data));
        if (res.data.userStatus == 2) {
          this.loginData = res.data;
        } else {
          window.df_sdk_common.location.href = res.data.pcLoginUri;
        }
      });
    },
    getFindUsableList() {
      // this.apis.headerApi.getFindUsableList().then(res => {
      //   this.unionMenu = res;
      // });
      this.apis.newBfdHeaderApi.getFindUsableList().then((res) => {
        // console.log('新百福得接口数据', res.data);
        this.unionMenu = res.data;
      });
    },
    getUnionLogoAndPhone() {
      this.apis.newBfdHeaderApi.getUnionLogoAndPhone().then((res) => {
        // console.log(res.data);
        // debugger;
        // this.unionLogo = res.data.logo;
        this.unionPhone = res.data.tel;
        this.unionPhoneTime = res.data.customerTime;
      });
    },
    getCompanyInfo() {
      this.apis.newBfdHeaderApi.getCompanyInfo().then((res) => {
        if (res.data && res.data.themeConfig && res.data.themeConfig.logoUrl) {
          this.unionLogo = res.data.themeConfig.logoUrl;
        }
      });
    },
    getNoticeData() {
      // this.apis.headerApi.getNotice().then(res => {
      //   this.noticeData = res;
      // });
      this.apis.newBfdHeaderApi.getNotice().then((res) => {
        // console.log('新百福得接口数据', res.data);
        this.noticeData = res.data;
      });
    },
    goGio(isCiUrl, value) {
      let pathName = window.location.pathname;
      let channelName = "优选生活";
      if (pathName.indexOf("home") > -1) {
        channelName = "优选生活";
      } else if (pathName.indexOf("book") > -1) {
        channelName = "图书";
      } else if (pathName.indexOf("birthday") > -1) {
        channelName = "生日汇";
      } else if (getQueryString("productTypes")) {
        channelName = getQueryString("productTypes");
      }
      gioHandle("DF_elementClick", {
        df_channle: channelName,
        df_pagename: "搜索页",
        df_modulename: "搜索历史",
        df_elementname: "搜索历史词",
        df_searchKeyword: value,
        df_pageType: isCiUrl ? "词链" : "",
      });
    },
    async onSumbit(value) {
      const city =
        (Cookies.get("address") &&
          JSON.parse(Cookies.get("address") || "{}").cityId) ||
        "145";
      const res = await this.apis.headerApi.getSearchUrl({
        keyword: value,
        city,
      });
      if (res && res.body && res.body.linkUrl) {
        this.goGio(true, value);
        window.df_sdk_common.location.href = res.body.linkUrl;
      } else {
        this.goGio(false, value);
        window.df_sdk_common.location.href = `${this.unionHead.mallUnionConfigDto.pcSearchUrl}${value}`;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  line-height: 20px;
  padding-top: 4px;
  padding-bottom: 4px;
  min-width: 1200px;
  // &__left {
  //   float: left;
  //   width: 100%;
  //   height: 20px;
  // }
  &__wrapper {
    .wrapper();
  }
  &__user {
    height: 20px;
    text-align: right;
    > ul {
      display: inline-block;
    }
  }
  &__item {
    float: left;
    color: #fff;
    margin-left: 5px;
    > a {
      color: #fff;
    }
    &_en {
      &:before {
        content: "/";
        position: relative;
        top: -1px;
        margin-left: 1px;
        margin-right: 1px;
      }
    }
  }
}
.nav-bar {
  background-color: #2c2d78;
  padding: 14px 0px;
  line-height: 20px;
  &__wrapper {
    position: relative;
    .wrapper();
  }
}
.header-body {
  .wrapper();
  display: flex;
  height: 88px;
  align-items: center;
  .logo {
    height: 40px;
    margin: auto 0;
    margin-right: 25px;
  }
  .channels {
    margin-right: auto;
  }
  .contact {
    // height: 40px;
    height: auto;
    margin-right: 24px;
    min-width: 164px;
    .contact-tel {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      img {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
      span {
        font-size: 18px;
        // font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
      }
    }
    .contact-time {
      font-size: 14px;
      // font-family: MicrosoftYaHei;
      color: #666666;
      line-height: 19px;
    }
  }
}
</style>
